/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_Toast_Failed_TitleInputs */

const en_auth_login_toast_failed_title = /** @type {(inputs: Auth_Login_Toast_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-in failed`)
};

const pl_auth_login_toast_failed_title = /** @type {(inputs: Auth_Login_Toast_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logowanie nie powiodło się`)
};

/**
* | output |
* | --- |
* | "Sign-in failed" |
*
* @param {Auth_Login_Toast_Failed_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_login_toast_failed_title = /** @type {((inputs?: Auth_Login_Toast_Failed_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_Toast_Failed_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_login_toast_failed_title(inputs)
	return en_auth_login_toast_failed_title(inputs)
});